import { render, staticRenderFns } from "./withdrawSuccess.vue?vue&type=template&id=2acdc10c&scoped=true&"
import script from "./withdrawSuccess.vue?vue&type=script&lang=js&"
export * from "./withdrawSuccess.vue?vue&type=script&lang=js&"
import style0 from "./withdrawSuccess.vue?vue&type=style&index=0&id=2acdc10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdc10c",
  null
  
)

export default component.exports